<template>
    <w-card-tile
        :class="cardClass"
        v-bind="wCardTileProps"
        v-on="wCardTileEvents"
    >
        <v-card-text>
            <img v-if="logoPath" :src="logoPath" class="logo">
            <!-- @slot Default slot to contain the form message contents. -->
            <slot></slot>
        </v-card-text>
        <v-card-actions>
            <!-- @slot Actions slot to contain, for example, `WBtn`. -->
            <slot name="actions"></slot>
        </v-card-actions>
    </w-card-tile>
</template>

<style scoped lang="stylus">
    .logo
        display block
        height 60px
        margin 16px auto 36px auto
        max-width 250px
</style>

<script>
    import WCardTile from '../WCardTile'
    import WCardTileMixin from '../../mixins/w-card-tile-mixin'

    /**
     * A form-styled component that contains a slot to contain messages e.g. form closed, form error etc.
     */
    export default {
        name: 'WFormMessage',
        mixins: [WCardTileMixin],
        components: {
            WCardTile
        },
        props: {
            /**
             * Center the text of the form by applying the `text-xs-center` CSS class.
             */
            centerText: {
                type: Boolean,
                default: true,
            },
            /**
             * Path to the logo.
             */
            logoPath: {
                type: String,
                default: ''
            },
        },
        computed: {
            cardClass () {
                const vm = this
                const elevation = vm.flat ? '' : 'elevation-12'
                const alignment = vm.centerText ? 'text-xs-center' : ''
                return `${elevation} ${alignment}`
            }
        }
    }
</script>
